
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { SaveProfileLawyerSignatureCommand } from "../services/api/models/SaveProfileLawyerSignatureCommand.model";
import { profileApi } from "../services/api/profile/profile";

@Component({})
export default class LaywerSignatureModal extends Vue {
  @Prop() readonly showLaywerSignatureModal: any;
  @Prop() readonly item: any;
  @Prop() readonly text: any;

  private id = "";
  private step = 1;
  private verified = false;
  private name = "";
  private ruc = "";
  private position = "";
  private email = "";
  private administrator = "";
  private emailAdministrator = "";
  private isValidationLoading = false;

  $t: any;

  @Watch("item")
  onPropertyChanged(value: boolean, oldValue: boolean) {
    if (value) {
      this.setItem(value);
    }
  }

  async setItem(item: any) {
    this.id = item.id;
    this.name = item.name;
    this.ruc = item.ruc;
    this.position = item.position;
    this.email = item.email;
    this.administrator = item.administrator;
    this.emailAdministrator = item.emailAdministrator;
  }

  async nextLawyerSignature() {
    if (
      this.name === "" ||
      this.ruc === "" ||
      this.position === "" ||
      this.email === "" ||
      this.administrator === "" ||
      this.emailAdministrator === ""
    ) {
      this.$emit("errorMessage", "Debes llenar los campos requeridos");
      return;
    }

    this.saveLawyerSignature();
  }

  async saveLawyerSignature() {
    this.isValidationLoading = true;
    try {
      let signatureId = await profileApi.setLawyerSignatureProfile(
        new SaveProfileLawyerSignatureCommand(
          this.name,
          this.ruc,
          this.position,
          this.email,
          this.administrator,
          this.emailAdministrator,
          "",
          this.id
        )
      );
      this.id = signatureId;
      this.$emit("closeModal");
    } catch (error) {
      let data = error?.response?.data;
      if (error?.response?.status === 404) {
        this.$emit("errorMessage", data);
      } else if (
        error?.response?.status === 400 &&
        Object.keys(data).length > 0
      ) {
        let message = "<ul>";
        Object.keys(data).forEach((item: any) => {
          if (data[item]) {
            data[item].forEach((row: any) => {
              let text = this.$t(`errors.${row["errorCode"]}`);
              message += `<li>${text}</li>`;
            });
          }
        });
        message += "</ul>";
        this.$emit("errorMessage", message);
      } else if (data) {
        this.$emit("errorMessage", this.$t(`errors.${data}`));
      } else if (error) {
        this.$emit("errorMessage", error);
      }
    } finally {
      this.isValidationLoading = false;
    }
  }

  async closeLaywerSignatureModal() {
    this.$emit("closeModal");
  }

  async previousLawyerSignature() {
    this.step--;
  }
}
